export default __webpack_public_path__ + "static/image2-cd1dc28214a25b32944d8ac116940f00.webp";